import styled, { css } from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export interface MapControlStyledProps {
  $active?: boolean
  $size?: 'small' | 'medium' | 'large'
}

const sizeStyles = {
  small: css`
    width: 32px;
    height: 32px;

    .icon {
      width: 14px;
      height: 14px;
    }
  `,
  medium: css`
    width: 40px;
    height: 40px;

    .icon {
      width: 16px;
      height: 16px;
    }
  `,
  large: css`
    width: 48px;
    height: 48px;

    .icon {
      width: 20px;
      height: 20px;
    }
  `,
}

export const Container = styled.button.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<MapControlStyledProps>`
  background: ${({ theme }) => theme.colors.background.primary};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};

  ${({ $size = 'medium' }) => sizeStyles[$size]}

  &:hover:not(:disabled) {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.primary};
      color: ${theme.colors.text.inverse};
    `}

  .icon {
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    flex-shrink: 0;
  }

  /* Touch devices: ensure adequate touch target */
  ${media.touch} {
    min-width: 36px;
    min-height: 36px;
  }

  ${media.tabletDown} {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    border-radius: ${({ theme }) => theme.borderRadius.default};

    .icon {
      width: 14px;
      height: 14px;
    }
  }

  ${media.mobileOnly} {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;

    .icon {
      width: 16px;
      height: 16px;
    }
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover:not(:disabled) {
      box-shadow: ${({ theme }) => theme.shadows.md};
      transform: none;
    }

    &:active:not(:disabled) {
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
      transform: scale(0.95);
    }
  }
`
